module.exports = "<div class=\"col-md-9\">\n  {% block colLeft %}{% endblock %}\n</div>\n<div class=\"col-md-3\">\n  {% block colRight %}{% endblock %}\n</div>\n";
